export default __webpack_public_path__ + "static/media/05_cosmos_m.ca3862ea.webp";